import React from "react";
import { useHistory } from "react-router-dom";
// Limitless imports
import { recordPageView } from "./AnalyticsHelper";
export const isAnalyticsEnabled = typeof process.env.REACT_APP_GA_ID === "string";
export const usePageViewRecorder = pageTitle => {
  const history = useHistory();
  React.useEffect(() => {
    if (isAnalyticsEnabled && pageTitle) {
      recordPageView(pageTitle, history.location.pathname);
    }
  }, [pageTitle]);
};